import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";
import { CATEGORIES } from "@/data/content";

export default function Categories() {
  return (
    <section data-testid="categories-section" className="section-pad bg-bg">
      <div className="max-w-7xl mx-auto container-px">
        <SectionHeader
          eyebrow="Categorii produse"
          title="Produse făcute pentru ritmul unei bucătării adevărate."
          subtitle="Când ai clienți la masă, nu ai timp de incertitudini. Ai nevoie de produse sigure, gustoase și ușor de pregătit."
          testId="categories-header"
        />

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-12 gap-5">
          {CATEGORIES.map((cat, i) => {
            // bento: featured one (idx 3 = blat pizza) bigger
            const isFeatured = cat.id === "blat-pizza";
            return (
              <motion.div
                key={cat.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className={`${isFeatured ? "lg:col-span-6 lg:row-span-2" : "lg:col-span-3"}`}
                data-testid={`category-card-${cat.id}`}
              >
                <Link
                  to={cat.id === "blat-pizza" ? "/blat-pizza" : cat.id === "croissante" ? "/croissante" : "/produse"}
                  className="product-card group block h-full"
                >
                  <div className={`relative overflow-hidden ${isFeatured ? "h-[480px]" : "h-[280px]"}`}>
                    <img src={cat.image} alt={cat.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                    <div className="absolute inset-0 p-6 flex flex-col justify-end">
                      <p className="eyebrow text-gold mb-2">{isFeatured ? "Categorie vedetă" : "Categorie"}</p>
                      <h3 className="font-display text-2xl md:text-3xl text-white">{cat.name}</h3>
                      <p className="mt-2 text-sm text-white/80 max-w-md leading-relaxed">{cat.desc}</p>
                      <div className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold">
                        Explorează <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
